module.exports = __webpack_public_path__ + "static/media/site.ea77d375.png";